import { render, staticRenderFns } from "./BaseSummary.vue?vue&type=template&id=600982ae&"
import script from "./BaseSummary.vue?vue&type=script&lang=js&"
export * from "./BaseSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports